jQuery(document).ready(function ($) {

    var review_header = 'review_header';
});

